import React from 'react'
import clsx from 'clsx'
import Button from '@material-ui/core/Button'
import {makeStyles} from '@material-ui/core/styles'
import {Link as RouterLink} from 'react-router-dom'

const useStyles = makeStyles(theme => ({
    subMenuButton: {
        color: theme.palette.common.white,
        margin: '0 0 0 0',
        padding: '10px 10px 0 10px',
        lineHeight: '0rem',
        boxShadow: 'none',
        height: '0.825rem',
        textTransform: 'uppercase',
        fontSize: '0.7rem',
        '&:hover': {
            boxShadow: 'none',
            opacity: 0.8,
        },
    },
    subMenuItemActive: {
        boxShadow: 'none',
        opacity: 0.8,
    },
}))

const SubMenuButton = props => {
    const classes = useStyles()
    const {pathname, route, name} = props

    return (
        <Button
            className={clsx(
                classes.subMenuButton,
                pathname === route && classes.subMenuItemActive
            )}
            component={RouterLink}
            to={route}
        >
            {name}
        </Button>
    )
}

export default SubMenuButton
